var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.advantages.length
    ? _c(
        "section",
        {
          staticClass: "lpu-advantages d-flex flex-column",
          class: _setup.isMobile ? "ga-6" : "ga-8",
          attrs: { "data-qa": "lpu_advantages" },
        },
        [
          _c(
            "h2",
            {
              staticClass: "text--text",
              class: _setup.isMobile ? "text-h6" : "text-h5",
              attrs: { "data-qa": "lpu_advantages_title" },
            },
            [_vm._v("\n    " + _vm._s(_setup.tStatic("Преимущества")) + "\n  ")]
          ),
          _vm._v(" "),
          _setup.isMobile
            ? [
                _vm.videoUrl && _vm.videoUuid
                  ? _c(_setup.AdvantageVideo, {
                      attrs: {
                        "video-url": _vm.videoUrl,
                        "video-uuid": _vm.videoUuid,
                        "preview-url": _vm.previewUrl,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex flex-column ga-6" },
                  _vm._l(_vm.advantages, function (item, index) {
                    return _c(_setup.AdvantageItem, {
                      key: `${item.icon.slug}-${index}`,
                      attrs: { advantage: item },
                    })
                  }),
                  1
                ),
              ]
            : _vm.videoUrl && _vm.videoUuid
            ? _c(
                "div",
                {
                  staticClass:
                    "lpu-advantages__layout lpu-advantages__layout--with-video",
                },
                [
                  _vm._l(_vm.advantages, function (item, index) {
                    return _c(_setup.AdvantageItem, {
                      key: `${item.icon.slug}-${index}`,
                      staticClass: "lpu-advantages__item",
                      class:
                        index % 2 === 0
                          ? "lpu-advantages__item--left"
                          : "lpu-advantages__item--right",
                      style: { gridRow: Math.floor(index / 2) + 1 },
                      attrs: { advantage: item },
                    })
                  }),
                  _vm._v(" "),
                  _c(_setup.AdvantageVideo, {
                    staticClass: "lpu-advantages__video",
                    class: {
                      "lpu-advantages__video--desktop": !_setup.isMobile,
                    },
                    attrs: {
                      "video-url": _vm.videoUrl,
                      "video-uuid": _vm.videoUuid,
                      "preview-url": _vm.previewUrl,
                    },
                  }),
                ],
                2
              )
            : _c(
                "div",
                { staticClass: "lpu-advantages__list--desktop" },
                _vm._l(_vm.advantages, function (item, index) {
                  return _c(_setup.AdvantageItem, {
                    key: `${item.icon.slug}-${index}`,
                    attrs: { advantage: item },
                  })
                }),
                1
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }